import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InlineNotificationComponent } from '@pure/hive';

/**
 * The "Renew Your Subscription" notice a recommendation dialog shows when it carries an
 * end-of-support-contract recommendation. It spans its container, as it does in the legacy
 * recommendation modal.
 */
@Component({
    selector: 'eosc-renewal-notice',
    templateUrl: './eosc-renewal-notice.component.html',
    styleUrls: ['./eosc-renewal-notice.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [InlineNotificationComponent],
})
export class EoscRenewalNoticeComponent {}
